import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useCustomerInfo from "../../hooks/useCustomerInfo";
import Loader from "../../modules/Loader";
import PopReciverInfo from "../../pages/Home/Components/Popups/CartPages/PopReciverInfo";
import { ReceiverData } from "../../pages/Home/Components/Popups/CartPages/utils";
import { appSharedColors } from "../styles/reactStyles";
interface SelectReciverModalProps {
  onPressClose: (selectedItem?: ReceiverData, buttonPressed?: string) => void;
  // dataValue: ReceiverData[];
  accesssToken: string;
  customerId: string;
  selectedId: number;
}
const SelectReceiverModal: React.FC<SelectReciverModalProps> = (
  props: SelectReciverModalProps
) => {
  const { t } = useTranslation();
  const { loadReceipent, loading, receiverInfo, deleteReceiver } =
    useCustomerInfo();
  const { onPressClose, accesssToken, customerId, selectedId } = props;
  const [newReceiverId, setNewReceiverId] = useState<number>(0);
  const [showNewReciverModal, setShowNewReciverModal] =
    useState<boolean>(false);
  const hideModalHandler = () => {
    setShowNewReciverModal(false);
  };
  const showReceiverModal = () => {
    setShowNewReciverModal(true);
  };
  const onNewReceiverAdded = (newId: number) => {
    // console.log(newId);
    setNewReceiverId(newId);
    // receiverInfo.forEach((element) => {
    //   console.log(element);
    //   if (element.id === newId) {
    //     console.log(element);
    //     onPressClose(element, "select");
    //     // return;
    //   }
    // });
  };
  const deleteReceiverHandler = (receiverId: string) => {
    deleteReceiver(accesssToken, receiverId).then((success) => {
      if (success) {
        onPressClose({} as ReceiverData, "delete");
        loadReceipent(accesssToken, parseInt(customerId));
      }
    });
  };
  useEffect(() => {
    if (!showNewReciverModal) {
      loadReceipent(accesssToken, parseInt(customerId));
    }
  }, [showNewReciverModal]);

  useEffect(() => {
    if (newReceiverId !== 0 && receiverInfo !== undefined) {
      receiverInfo.forEach((element) => {
        console.log(element);
        if (element.id === newReceiverId) {
          console.log(element);
          onPressClose(element, "select");
          return;
        }
      });
    }
  }, [newReceiverId, receiverInfo]);
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.2)",
        }}
        onClick={() => {
          onPressClose(undefined, "close");
        }}
      >
        <div
          id="pop_delivery"
          className="pop_up_maps_main"
          // onClick={() => onPressClose(undefined, "close")}
        >
          <div className="popup_delivery popup_from_bottom popup_slide">
            <div className="content" id="">
              <br />
              {!loading ? (
                <div>
                  {receiverInfo?.length > 0 ? (
                    receiverInfo?.map((item, index) => {
                      return (
                        <div className="receiver-wrapper">
                          <div
                            className={`${
                              selectedId === item.id ? "text-color-store" : ""
                            }`}
                            style={{ width: "92%" }}
                            onClick={() => onPressClose(item, "select")}
                          >
                            {item.recipient_name}
                          </div>
                          <svg
                            onClick={() =>
                              deleteReceiverHandler(item.id.toString())
                            }
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1000 1000"
                            aria-disabled={loading}
                            fill="currentColor"
                            data-spec="icon-plus"
                            className="w-5 h-5"
                            style={{ width: 12, height: 12 }}
                          >
                            <path
                              fill="orange"
                              d="M844.9 233.4c-115.10000000000002 0.5-230.19999999999993 0.29999999999998295-345.29999999999995 0.29999999999998295v-0.09999999999999432h-345.3c-11.900000000000006 0-23.100000000000023-1.5999999999999943-20.100000000000023 17.400000000000006 17 107.69999999999999 33.20000000000002 215.5 49.80000000000001 323.20000000000005 16.30000000000001 106.39999999999998 35.19999999999999 212.39999999999998 48.099999999999994 319.0999999999999 6.700000000000017 55.80000000000007 53.900000000000006 107.70000000000005 118.00000000000003 106.70000000000005 99.19999999999999-1.6000000000000227 198.29999999999995-0.10000000000002274 297.5-0.5 66.69999999999993-0.2999999999999545 109.5-38.5 119.29999999999995-104.60000000000002 19.800000000000068-132.79999999999995 39.700000000000045-265.6 59.80000000000007-398.4 12.199999999999932-80.69999999999999 24.199999999999932-161.39999999999998 37.5-241.9 2.8999999999999773-18.19999999999999-2.800000000000068-21.19999999999999-19.300000000000068-21.19999999999999z m-317.19999999999993 149.4c-0.7000000000000455 160.90000000000003-0.10000000000002274 321.8-0.20000000000004547 482.7h-55.10000000000002c-0.0999999999999659-80.10000000000002-0.0999999999999659-160.29999999999995-0.0999999999999659-240.39999999999998h0.19999999999998863c0-82.39999999999998 0.5-164.8-0.39999999999997726-247.20000000000005 0-2.5 0.0999999999999659-4.599999999999966 0.2999999999999545-6.599999999999966h54.60000000000002c0.5 3.3000000000000114 0.7000000000000455 7.199999999999989 0.7000000000000455 11.5z m-288.90000000000003-11.5h55c1.3000000000000114 3.8000000000000114 2.099999999999966 8.300000000000011 2.8000000000000114 13.599999999999966 14.099999999999966 113.80000000000001 30.399999999999977 227.30000000000007 46.19999999999999 340.9 6.5 46.60000000000002 13.800000000000011 93 19.5 139.70000000000005h-55.69999999999999c-15-107.79999999999995-30.100000000000023-215.5-45-323.29999999999995-7.800000000000011-56.30000000000007-15.000000000000028-112.70000000000005-22.600000000000023-169.10000000000002l-0.19999999999998863-1.8000000000000114z m493.8 200.2c-13.600000000000023 98-28.399999999999977 195.79999999999995-40.200000000000045 294h-55.60000000000002c22.700000000000045-161.60000000000002 44.30000000000007-323.29999999999995 66.40000000000009-484.9 0.39999999999997726-2.8000000000000114 0.39999999999997726-6.100000000000023 0.6999999999999318-9.300000000000011h56.89999999999998c-0.599999999999909 4-1.7999999999999545 8.300000000000011-2.2999999999999545 11.800000000000011-8.399999999999977 62.89999999999998-17.100000000000023 125.69999999999999-25.899999999999977 188.39999999999998z m208.89999999999998-413.7c-10.799999999999955-25.700000000000017-28.5-46.80000000000001-48.200000000000045-66.10000000000001-21.5-21-45.799999999999955-33-77.39999999999998-32.2-60.799999999999955 1.5-121.60000000000002 0-182.39999999999998 0.5-13.200000000000045 0.10000000000000142-20.399999999999977-1.7999999999999972-24.5-16.6-8.5-30.599999999999998-27.700000000000045-43.199999999999996-59.299999999999955-43.3-34-0.10000000000000142-68.00000000000006-0.20000000000000143-102.00000000000006 0.09999999999999859-29.80000000000001 0.2-49.39999999999998 14.100000000000001-57.599999999999966 42.8-3.900000000000034 13.600000000000001-10 17.6-24.100000000000023 17.4-60.80000000000001-1-121.6-1-182.3-0.3999999999999986-53.5 0.5-116.79999999999998 53.3-128.7 105.5-3.6000000000000014 16.099999999999994 2 25.400000000000006 17.700000000000003 28.30000000000001 7.799999999999997 1.3999999999999773 15.799999999999997 1.5 23.700000000000003 1.5 133.9 0.09999999999999432 267.79999999999995 0.09999999999999432 401.6 0h182.29999999999995l184.5 0.09999999999999432c18.100000000000023 0 36.30000000000007 0.5 54.200000000000045-0.9000000000000057 24.600000000000023-1.9000000000000057 31.899999999999977-14.400000000000006 22.5-36.69999999999999z"
                            />
                          </svg>
                        </div>
                      );
                    })
                  ) : (
                    <div className="receiver-wrapper">
                      <text>No data found</text>
                    </div>
                  )}
                </div>
              ) : (
                <Loader
                  height={20}
                  width={20}
                  colorProp={appSharedColors.primaryColor}
                />
              )}

              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      {showNewReciverModal && (
        <PopReciverInfo
          onReceiverAdded={onNewReceiverAdded}
          onPressClose={hideModalHandler}
          accessToken={accesssToken}
          customerId={customerId}
        />
      )}
      {!showNewReciverModal && (
        <div className="address-modal-addnew" onClick={showReceiverModal}>
          <div
            // onClick={closeCnfirmOrderPop}
            className=" target_slide glyphicon glyphicon-chevron-right"
          ></div>
          <text style={{ marginLeft: 5, fontSize: 12 }}>NEW RECEIPENT</text>
        </div>
      )}
    </>
  );
};

export default SelectReceiverModal;
